export default {
  siteName: 'Yoybuy Spreadsheet',
  siteTagline: 'Лучшие таблицы товаров Taobao, Weidian и 1688',
  heroTitle: 'Yoybuy Spreadsheet — Лучшие таблицы товаров Taobao, Weidian и 1688',
  heroSubtitle: 'Используйте лучшие Yoybuy Spreadsheet для быстрого поиска товаров, безопасной доставки и выгодных покупок из Китая.',
  btnYoybuySheet: 'Yoybuy Sheet',
  btnBuyNow: 'Купить сейчас',
  btnGoToGuide: 'Читать руководство',
  yoybuySheet: 'Yoybuy Sheet',
  buyItNow: 'Купить сейчас',
  categoryTitle: 'Категории товаров',
  categoryPlaceholder: 'Выберите категорию',
  popularCategories: 'Популярные категории',
  whyChoose: 'Почему выбирают Yoybuy Spreadsheet',
  latestArticles: 'Последние статьи',
  readMore: 'Читать далее',
  backToHome: 'Вернуться на главную',
  footerAbout: 'Yoybuy Spreadsheet — ваш надёжный источник таблиц товаров для покупок на Taobao, Weidian и 1688 с доставкой в Россию.',
  footerQuickLinks: 'Быстрые ссылки',
  footerCategories: 'Категории',
  footerResources: 'Ресурсы',
  copyright: '© 2026 Yoybuy Spreadsheet. Все права защищены.',
  allCategories: 'Все категории',
  goToMainSite: 'Перейти на основной сайт',
  home: 'Главная',
  guide: 'Руководство',
};